import { SearchIcon } from "@heroicons/react/solid"
import Button from "components/button"
import Input from "components/input"
import Select from "components/select"
import { EventType } from "interfaces";
import moment from "moment";
import { useState } from "react";
import Datepicker from "react-tailwindcss-datepicker"; 
import { twMerge } from "tailwind-merge";
import { BOOLEAN_STATUS, EVENT_TYPE_OPTIONS, STATUS_OPTIONS } from "utills/constants";

export const Filter = ({ currentFilterValues, setFilters}: {currentFilterValues: any, setFilters: any}) => {

  const _handleSubmitFilter = () => {
    setFilters([
      {field: "q", operator: "contains", value: keyword},
      {field: "is_active", operator: "eq", value: isActive},
      {field: "event_type", operator: "eq", value: eventType},
      {field: "use_whitelabel_integration", operator: "eq", value: isPartyIntegration},
      {field: "gte", operator: "eq", value: createdDate.startDate ? moment(createdDate.startDate).format('YYYY-MM-DD') : ""},
      {field: "lte", operator: "eq", value: createdDate.endDate ? moment(createdDate.endDate).format('YYYY-MM-DD') : ""},
      {field: "page", operator: "eq", value: 1}
    ])
  }

  const [keyword, setKeyword] = useState(currentFilterValues.q);
  const [isActive, setIsActive] = useState<string>(currentFilterValues.is_active);
  const [isPartyIntegration, setIsPartyIntegration] = useState(currentFilterValues.use_whitelabel_integration);
  const [eventType, setEventType] = useState<string>(currentFilterValues.event_type);
  const [createdDate, setCreatedDate] = useState({
    startDate: currentFilterValues.gte || "", 
    endDate: currentFilterValues.lte || ""
  });
  
  return (
    <div className="w-full">
      <div className="flex flex-col gap-y-4 md:flex-row md:flex-w md:items-end md:gap-x-3">
        <div className="flex-1">
          <label htmlFor="role" className="block text-sm font-medium leading-6">
            Search
          </label>
          <div className="mt-2">
            <Input 
              className="px-2 py-2"
              label='Search by Role name'
              id='role'
              type="text"
              placeholder="Search by Organization name"
              value={keyword}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyword(e.target.value)}
              onKeyDown={(e: React.KeyboardEvent) => {
                if (e.key === 'Enter') {
                  _handleSubmitFilter();
                }
              }}
            />
          </div>
        </div>
        <div className="flex-1">
          <label htmlFor="created_date" className="block text-sm font-medium leading-6">
            Created Date
          </label>
          <div className="mt-2">
            <Datepicker 
              value={createdDate}
              onChange={(value) => setCreatedDate({
                startDate: value?.startDate ? moment(value?.startDate).format('YYYY-MM-DD') : "",
                endDate: value?.endDate ? moment(value?.endDate).format('YYYY-MM-DD') : ""
              })}
              displayFormat="DD/MM/YYYY"
              placeholder="Start date - End date"
              inputClassName="date-picker"
              popoverDirection="down"
              containerClassName={(className) => twMerge(className, "date-picker-container")}
            /> 
          </div>
        </div>
        <div className="flex-1">
          <label htmlFor="status" className="block text-sm font-medium leading-6">
            Status
          </label>
          <div className="mt-2">
            <Select 
              options={STATUS_OPTIONS} 
              isClearable={true}
              id="status"
              placeholder="Select Status"
              className="py-0.5"
              value={STATUS_OPTIONS.find((d) => d.value === isActive)}
              onChange={(selected: {label: string; value: "true" | "false"}) => setIsActive(selected?.value)}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-y-4 mt-4 md:flex-row md:flex-w md:items-end md:gap-x-3">
        <div className="flex-1">
          <label htmlFor="event_type" className="block text-sm font-medium leading-6">
            Event Type
          </label>
          <div className="mt-2">
            <Select 
              options={EVENT_TYPE_OPTIONS} 
              isClearable={true}
              id="event_type"
              placeholder="Select Event Type"
              className="py-0.5"
              value={EVENT_TYPE_OPTIONS.find((d) => d.value === isActive)}
              onChange={(selected: {label: string; value: EventType}) => setEventType(selected?.value)}
            />
          </div>
        </div>
        <div className="flex-1">
          <label htmlFor="use_whitelabel_integration" className="block text-sm font-medium leading-6">
            3rd party integration
          </label>
          <div className="mt-2">
            <Select 
              options={BOOLEAN_STATUS} 
              isClearable={true}
              id="use_whitelabel_integration"
              placeholder="3rd party integration"
              className="py-0.5"
              value={BOOLEAN_STATUS.find((d) => d.value === isPartyIntegration)}
              onChange={(selected: {label: string; value: string}) => setIsPartyIntegration(selected?.value)}
            />
          </div>
        </div>
        <div className="shrink-0">
          <label htmlFor="status" className="block text-sm font-medium leading-6">
            <span className="sr-only">Search</span>
          </label>
          <div className="mt-2 w-full">
            <Button type="submit" className="w-full px-4 py-2 border-y-[1px] border-solid border-brand-500 rounded-md" onClick={_handleSubmitFilter}>
              <SearchIcon className="w-3 h-4 text-white mr-2" /> Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}